import { Grid, Paper } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { CustomerSettingsOverviewSearchFilter } from '../models/customerSettingsOverviewSearchFilter';
import { CustomerSettingsDataGrid } from '../components/customerSettingsDataGrid';

export const CustomerSettingsOverviewPage = () => {
  const { t } = useTranslation();

  const [customerSettingsOverviewFilter, setCustomerSettingsOverviewFilter] = useState<CustomerSettingsOverviewSearchFilter>({
    sortCol: 'lastName',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as CustomerSettingsOverviewSearchFilter);

  return (
    <>
      <GridWrapper>
        <Grid item xs={12} md={4}>
          <MainContentHeader title={t('customer:header')} />
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <CustomerSettingsDataGrid
              searchFilter={customerSettingsOverviewFilter}
              searchFilterCallback={(newFilter) =>
                setCustomerSettingsOverviewFilter((prev) => ({
                  ...prev,
                  ...newFilter,
                }))
              }
            />
          </Paper>
        </Grid>
      </GridWrapper>
    </>
  );
};
